<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide class="slide-2"
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"
        ></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}">
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          lazy: {
            loadPrevNext: true
          },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/1.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/2.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/3.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/4.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/5.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/6.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/7.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/8.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/9.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/10.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/11.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/12.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/13.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/14.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/15.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/16.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/17.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/18.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/19.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/20.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/21.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/22.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/23.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/24.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/25.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/26.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/27.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/28.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/29.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/30.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/31.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/32.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/33.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/34.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/35.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/36.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/37.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/38.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/39.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/40.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/41.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/42.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/43.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/44.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/45.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/46.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/47.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/48.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/49.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/50.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/51.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/52.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/53.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/54.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/55.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/56.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/57.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/58.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/59.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/60.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/61.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/62.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/63.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/64.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/65.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/66.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/67.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/68.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/69.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/70.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/71.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/72.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/73.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/74.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/75.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/76.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/77.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/78.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/79.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/80.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/81.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/82.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/83.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/84.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/85.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/86.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/87.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/88.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/89.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/90.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/91.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/92.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/93.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/94.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/95.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/96.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/97.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/98.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/99.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/100.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/101.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/102.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/103.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/104.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/105.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/106.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/107.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/108.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/109.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/110.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/111.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/112.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/113.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/114.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/115.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/116.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/117.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/118.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/119.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/120.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/121.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/122.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/123.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/124.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/125.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/126.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/127.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/128.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/129.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/130.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/131.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/132.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/133.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/134.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/135.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/136.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/137.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/138.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/139.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/140.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/141.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/142.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/143.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/144.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/145.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/146.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/147.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/148.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/149.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/150.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/151.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/152.jpg',
          'https://dixcel.cn/prod/2018亚洲宝珀GT-亚洲F3上海站/153.jpg',

        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
